import { Text } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { IconX } from "@tabler/icons-react";
import { useCallback } from "react";
import { Flex } from "src/styled";
import { toMantineDateString } from "src/utils/mantineDates";

import { Button } from "../Button/Button";

export type DateRange = [string | null, string | null];

interface Props {
  dateRange: DateRange;
  setDateRange: (dateRange: DateRange) => void;
}
const DateRangeSelect = ({ dateRange, setDateRange }: Props) => {
  const [startDate, endDate] = dateRange;
  const handleClear = () => {
    setDateRange([null, null]);
  };

  const formatDate = useCallback((date: string | null) => {
    if (!date) return null;
    return date;
  }, []);

  const setDate = (index: number, date: string | null) => {
    const newDateRange = [...dateRange];
    newDateRange[index] = formatDate(date);
    setDateRange(newDateRange as DateRange);
  };
  return (
    <Flex gap={5} align="center" ml={10}>
      <Text size="sm">From</Text>
      <DateInput
        value={toMantineDateString(startDate)}
        onChange={v => setDate(0, v)}
        placeholder="Start Date"
        valueFormat="YYYY-MM-DD"
        maw={100}
      />
      <Text size="sm">To</Text>
      <DateInput
        value={toMantineDateString(endDate)}
        onChange={v => setDate(1, v)}
        placeholder="End Date"
        valueFormat="YYYY-MM-DD"
        maw={100}
      />
      {startDate || endDate ? (
        <Button onClick={handleClear} variant="outline" w={30} h={30} p={0}>
          <IconX size={20} />
        </Button>
      ) : (
        <div style={{ width: 30, height: 30 }}></div>
      )}
    </Flex>
  );
};
export default DateRangeSelect;
